import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  RegisterFcmTokenLoading: false,
  RegisterFcmTokenError: null,
  RegisterFcmTokenSuccess: false,

  notifications: [],
  getNotificationLoading: false,
  getNotificationError: null,
  getNotificationSuccess: false,

  markAllAsReadLoading: false,
  markAllAsReadError: null,
  markAllAsReadSuccess: false,

  getSampleNotificationLoading: false,
  getSampleNotificationError: null,
  getSampleNotificationSuccess: false,
  sampleNotification: [],
};

const NotificationsSlice = createSlice({
  name: "Notifications",
  initialState,
  reducers: {
    RegisterFcmTokenRequest: (state) => {
      state.RegisterFcmTokenLoading = true;
      state.RegisterFcmTokenError = null;
      state.RegisterFcmTokenSuccess = false;
    },

    RegisterFcmTokenSuccess: (state, action) => {
      state.RegisterFcmTokenLoading = false;
      state.RegisterFcmTokenError = null;
      state.RegisterFcmTokenSuccess = true;
    },
    RegisterFcmTokenFailure: (state, action) => {
      state.RegisterFcmTokenLoading = false;
      state.RegisterFcmTokenError = action.payload;
      state.RegisterFcmTokenSuccess = false;
    },

    getNotificationRequest: (state) => {
      state.getNotificationLoading = true;
      state.getNotificationError = null;
      state.getNotificationSuccess = false;
    },

    getNotificationSuccess: (state, action) => {
      state.getNotificationLoading = false;
      state.getNotificationError = null;
      state.getNotificationSuccess = true;
      state.notifications = action.payload;
    },

    getNotificationFailure: (state, action) => {
      state.getNotificationLoading = false;
      state.getNotificationError = action.payload;
      state.getNotificationSuccess = false;
    },

    markAllAsReadRequest: (state) => {
      state.markAllAsReadLoading = true;
      state.markAllAsReadError = null;
      state.markAllAsReadSuccess = false;
    },

    markAllAsReadSuccess: (state) => {
      state.markAllAsReadLoading = false;
      state.markAllAsReadError = null;
      state.markAllAsReadSuccess = true;
    },

    markAllAsReadFailure: (state, action) => {
      state.markAllAsReadLoading = false;
      state.markAllAsReadError = action.payload;
      state.markAllAsReadSuccess = false;
    },

    getSampleNotificationRequest: (state) => {
      state.getSampleNotificationLoading = true;
      state.getSampleNotificationError = null;
      state.getSampleNotificationSuccess = false;
    },

    getSampleNotificationSuccess: (state, action) => {
      state.getSampleNotificationLoading = false;
      state.getSampleNotificationError = null;
      state.getSampleNotificationSuccess = true;
      state.sampleNotification = action.payload;
    },

    getSampleNotificationFailure: (state, action) => {
      state.getSampleNotificationLoading = false;
      state.getSampleNotificationError = action.payload;
      state.getSampleNotificationSuccess = false;
    },

    clearStates(state) {
      state.RegisterFcmTokenSuccess = false;
      state.RegisterFcmTokenError = null;
      state.getNotificationSuccess = false;
      state.getNotificationError = null;
      state.markAllAsReadSuccess = false;
      state.markAllAsReadError = null;
      state.getSampleNotificationSuccess = false;
      state.getSampleNotificationError = null;
    },
  },
});

export const NotificationsActions = NotificationsSlice.actions;
export default NotificationsSlice.reducer;
